import type { LabelledEntity } from 'shared/types/commonView';
import { createEntityMapById } from './entityIds';

export function idsToLabelledEntities(
  ids: readonly string[],
  labelledEntities: readonly LabelledEntity[]
): LabelledEntity[] {
  if (ids.length === 0 || labelledEntities.length === 0) {
    return [];
  }

  const entitiesById = createEntityMapById(labelledEntities);

  return ids
    .map((id) => {
      const foundEntity = entitiesById.get(id);
      return foundEntity
        ? {
            _id: foundEntity._id,
            label: foundEntity.label,
          }
        : undefined;
    })
    .filter((x): x is LabelledEntity => Boolean(x));
}
